export default __webpack_public_path__ + "static/media/carousel_mvp.e86c1f24.png";